import React from 'react';
import AdminDashboard from '../../components/layout/AdminDashboard';
import AdminPanel from '../../components/admin/AdminPanel';
import { useAuth } from '../../context/AuthContext';
import { Routes, Route, useNavigate } from 'react-router-dom';

/**
 * AdminDashboardPage Component
 * 
 * Orchestrates the Admin area by handling sub-routes for:
 * - /admin: Selection dashboard (Tool selection)
 * - /admin/*: Direct Admin Panel access (User management, etc.)
 * 
 * Uses internal <Routes> to handle deep-linking from the global Sidebar.
 * 
 * @component
 */
const AdminDashboardPage = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    const handleAdminModeSelect = (mode) => {
        if (mode === 'tools') {
            navigate('/tools');
        } else if (mode === 'verwaltung') {
            navigate('/verwaltung');
        } else {
            navigate('/admin/users'); // Go straight to users if admin panel selected
        }
    };

    const handleOpenJournalProject = (project) => {
        navigate(`/tools/journal/${project.id}`, {
            state: { fromAdmin: true }
        });
    };

    return (
        <Routes>
            <Route index element={
                <div className="admin-dashboard-wrapper">
                    <AdminDashboard user={user} onSelectMode={handleAdminModeSelect} />
                </div>
            } />
            <Route path="*" element={
                <div className="admin-page-content">
                    <AdminPanel
                        onOpenJournalProject={handleOpenJournalProject}
                    />
                </div>
            } />
        </Routes>
    );
};

export default AdminDashboardPage;
